import api from "@/app/api";
import Private from "@/app/components/Private";
import TablePage from "@/app/components/TablePage";
import { ApiContext } from "@/app/contexts/ApiContext";

export default function MediaRates() {
  return (
    <ApiContext.Provider
      value={{
        listData: api.getMediaRates,
        getFieldOptions: api.getMediaRateFieldOptions,
        getData: api.getMediaRate,
        getFields: api.getMediaRatesFields,
        updateEntry: api.updateMediaRate,
        deleteEntry: api.deleteMediaRate,
        createEntry: api.createMediaRate,
        createFieldOption: api.createMediaRateFieldOption,
      }}
    >
      <Private>
        <TablePage searchPlaceholder="Search by media description..." />
      </Private>
    </ApiContext.Provider>
  );
}
